import React, { useEffect, useState } from 'react';
import { UseFormMethods } from 'react-hook-form';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import InvoiceType from 'src/models/InvoiceType';

interface IInvoiceTypeListProps extends Partial<Pick<UseFormMethods, 'register' | 'errors' | 'control'>> {
    typeList: Array<InvoiceType>;
    selectedTypeList: Array<InvoiceType>;
    getValues: () => { [x: string]: unknown; };
    resetValues: (i: number) => void;
}

const InvoiceTypeList = (props: IInvoiceTypeListProps) => {
    const addNewType = () => {
        let newType: InvoiceType = {
            id: 0,
            code: 0,
            description: ''
        };

        let newList = [...invoiceTypes, newType];

        setInvoiceTypes(newList);
    };

    const [invoiceTypes, setInvoiceTypes] = useState<InvoiceType[]>([]);

    useEffect(() => {
        console.log('Form values', props.getValues());
        if (props.selectedTypeList?.length > 0) {
            setInvoiceTypes([...props.selectedTypeList]);
        } else {
            setInvoiceTypes([]);
        }
    }, [props.selectedTypeList]);

    useEffect(() => {
        displayInvoiceTypes();
    }, [invoiceTypes]);

    const displayInvoiceTypes = () => {
        return (
            <div>
                {invoiceTypes?.map((field, index) => {
                    return (
                        <div key={field.id} style={{ borderBottom: '1px solid darkgrey', marginBottom: '0.5rem', padding: '1rem' }}>
                            <div>{index + 1}</div>
                            <div>
                                <RHFSelect
                                    label="Invoice Type"
                                    name={`invoiceTypes[${index}].id`}
                                    register={props.register}
                                    errors={props.errors}
                                    options={props.typeList.map(tl => { return { value: tl.id, label: tl.description }; })}
                                />
                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Button onClick={() => props.resetValues(index)} text="Delete" size="small" />
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    };

    return (
        <>
            {displayInvoiceTypes()}

            <div>
                <Button onClick={addNewType} text="Add Invoice Type" />
            </div>
        </>
    );
};

export default InvoiceTypeList;


// WEBPACK FOOTER //
// ./src/components/project/sections/InvoiceTypeList.tsx